import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CsvIntegrationPage } from '@/areas/data-integrations/FileImports';
import { canViewOtherOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/csv-integration')({
    staticData: {
        access: { permissions: canViewOtherOrganizationSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CsvIntegrationPage />;
}
